import api from './client'

// 自更新接口 (v3.19.6) — backend internal/api/webui_update.go
//
// 信任边界: check 只读远端版本, 需登录即可; apply 会**替换服务器上的
// 二进制** (等于执行代码), 因此后端要求登录 + Bearer 令牌 + 请求体带
// confirm:"upgrade"。status 供面板轮询进度。

export interface UpdateState {
  running: boolean
  message: string
  error: string
  version: string
  updated_at: string
}

export interface UpdateCheckResponse {
  ok: boolean
  current_version: string
  latest_tag: string
  upgradable: boolean
  notes?: string
  error?: string
  binary_name: string
  download_url?: string
  state: UpdateState
}

export interface UpdateApplyResponse {
  ok: boolean
  version: string
  backup?: string
  message: string
  rebooting: boolean
}

export async function checkUpdate(): Promise<UpdateCheckResponse> {
  return api.get<UpdateCheckResponse>('/api/update/check')
}

export async function applyUpdate(): Promise<UpdateApplyResponse> {
  // confirm 是后端要求的二次确认标记 — 挡 CSRF 与误触。
  return api.post<UpdateApplyResponse>('/api/update/apply', { confirm: 'upgrade' })
}

export async function getUpdateStatus(): Promise<{ ok: boolean; state: UpdateState }> {
  return api.get<{ ok: boolean; state: UpdateState }>('/api/update/status')
}
